import React from 'react';
import { VStack, Text, Button, Input, Box } from '@chakra-ui/react';
import { ArrowForwardIcon } from '@chakra-ui/icons';
import LogoSection from './LogoSection';

function maskPhone(phone) {
  if (!phone || phone.length < 5) return phone;
  return phone.slice(0, 5) + 'XXXX' + phone.slice(-2);
}

function formatTimer(seconds) {
  const m = String(Math.floor(seconds / 60)).padStart(1, '0');
  const s = String(seconds % 60).padStart(2, '0');
  return `${m}:${s}`;
}

const OTPVerificationCardContent = ({
  mode = 'phone',
  phone,
  email,
  onNext,
  onResend,
  resendTimer,
  otpValue,
  onOtpChange
}) => (
  <VStack spacing={4} align="stretch">
    <LogoSection />
    <Text fontSize="2xl" fontWeight="bold" color="gray.800" textAlign="center">
      OTP Verification
    </Text>
    <Text color="gray.500" fontSize="sm" textAlign="center" mb={2}>
      {mode === 'phone' ? (
        <>
          An OTP has been sent to your registered mobile number, <b>{maskPhone(phone)}</b>.<br/>
          Please check your SMS to proceed.<br/>
        </>
      ) : (
        <>
          An OTP has been sent to your email address, <b>{email}</b>.<br/>
          Please check your email to proceed.<br/>
        </>
      )}
      The <b>Resend OTP</b> button will be activated in 1:30 minutes.
    </Text>
    <Input
      placeholder="Enter Enter account key"
      size="lg"
      value={otpValue}
      onChange={onOtpChange}
      mb={2}
    />
    <Button colorScheme="blue" size="lg" w="full" rightIcon={<ArrowForwardIcon />} onClick={onNext}>
      Next
    </Button>
    <Box textAlign="center" mt={2}>
      <Button
        variant="link"
        colorScheme="gray"
        isDisabled={resendTimer > 0}
        onClick={onResend}
        fontWeight="bold"
        fontSize="md"
      >
        Resend OTP
      </Button>
      <Text as="span" color="#000B8C" fontWeight="bold" fontSize="md" ml={2}>
        {resendTimer > 0 ? formatTimer(resendTimer) : ''}
      </Text>
    </Box>
  </VStack>
);

export default OTPVerificationCardContent; 